export const admiralAdblockRecovery = {
    id: 'AdmiralAdblockRecovery',
    author: '@commercial-dev',
    start: '2025-08-13',
    expiry: '2027-01-21',
    audience: 100 / 100,
    audienceOffset: 0 / 100,
    audienceCriteria: '',
    successMeasure: '',
    description: 'Test the Admiral ad blocker detection integration ahead of go-live',
    variants: [
        {
            id: 'control',
            test: () => {
                /* no-op */
            },
        },
        /**
         * variant-detect will run the Admiral script but will not launch
         * the recovery modal for users with ad blockers
         */
        {
            id: 'variant-detect',
            test: () => {
                /* no-op */
            },
        },
        /**
         * variant-recover will run the Admiral script and launch the
         * recovery modal for users with ad blockers
         */
        {
            id: 'variant-recover',
            test: () => {
                /* no-op */
            },
        },
    ],
    canRun: () => true,
};
